import React from 'react';

import _ from 'lodash';

import ValidationProductTableRow from './ValidationProductTableRow';
import InputTextField from './InputTextField';

import './ValidationProductTable.scss';

class ValidationProductTable extends React.Component {

  // state object set to an empty string. 
  state = {
    newProduct: ''
  }

  // click handler that uses the state (newProduct) object.
  handleAddProductClick = () => {
    const { newProduct } = this.state;

    if (newProduct !== "") {
      this.props.onValidationProductChange(null, newProduct);
      this.setState({ newProduct: '' });
    }
  }

  // sets the state created on line 13. 
  _onProductInputChange = val => {
    this.setState({
      newProduct: val
    });
  }

  handleDeleteProductClick = ident => {
    return () => {
      this.props.onValidationProductChange(ident, null)    }
  }

  render() {
    const {
      inputId,
      validationProducts,
      editMode
    } = this.props;

    const validationProductTableRows = validationProducts.map((productName, index) => {
      return { ident: index, productName };
    });

    return (
      <div className="parkchirp--validation-product-table">
        <div className="parkchirp--validation-product-table--body">
          {validationProductTableRows.map(productRow => {
            return (
              <div className="parkchirp--validation-product-table-row--product-cell-row" key={productRow.ident} >
                <ValidationProductTableRow
                  data={productRow}
                  editMode={editMode}
                  onDelete={this.handleDeleteProductClick(productRow.ident)}
                />
              </div>
            )
          })}
          {editMode &&
            <div className="parkchirp--field-container parkchirp--field-container--columns" >
              <div className="parkchirp--input-select-field">
                <InputTextField
                    inputId={inputId}
                    value={this.state.newProduct}
                    onChange={this._onProductInputChange}
                    editMode={editMode}
                />
              </div>
              <button
                type="button"
                className="parkchirp--button-as-link add-product-button"
                onClick={this.handleAddProductClick}>
                Add Product
              </button>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default ValidationProductTable;